var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(typeof _vm.date == 'object' && _vm.date !== null)?_c('label',[_vm._v(_vm._s(_vm.date.toShortDateString()))]):_vm._e(),(typeof _vm.date == 'string')?_c('label',[_vm._v(_vm._s(new Date(_vm.date).toShortDateString()))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }